import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotRecommend from './components/HotRecommend';
import LatestUpdates from './components/LatestUpdates';
import NewsSection from './components/NewsSection';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '四虎影视',
            url: 'https://whlcfood.cn',
            description: '四虎影视提供海量高清影视资源，涵盖最新电影、热门电视剧、综艺节目等内容，无需注册即可免费在线观看。',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://whlcfood.cn/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '四虎影视',
            url: 'https://whlcfood.cn',
            description: '海量高清影视资源免费在线观看平台',
            foundingDate: '2018',
            contactPoint: {
              '@type': 'ContactPoint',
              contactType: 'customer service',
              email: 'contact@sihumovies.com',
            },
          }),
        }}
      />

      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <HotRecommend />
        <LatestUpdates />
        <NewsSection />
      </main>
      <Footer />
    </>
  );
}